<template>
  <!--   Big container   -->
  <div class="container">
    <div class="row">

      <div class="col-sm-8 col-sm-offset-2">

        <div style="text-align: center; margin-top: 2rem;">
          <a href="javascript:void(0);" @click="abrirSiteCliente()" >
            <img src="assets/img/urbs/logo.png" /> 
          </a>
        </div>
        <!--      Wizard container        -->
        <div class="wizard-container" style="padding-top: 25px;">
          <div class="card wizard-card" data-color="blue" id="wizard" style="display: block; min-height: 20rem;">
            <form action="" method="" novalidate="novalidate">
              
              <!-- ==================== -->
              <!-- TITULO E DESCRIÇÃO   -->
              <!-- ==================== -->
              <div class="wizard-header">
                  <h3 class="wizard-title">
                    <!-- <i class="material-icons">info_outline</i>  -->
                    Opsss!
                  </h3>
                <h5>Pagina não encontrada.</h5>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="footer">
    <div class="container text-center">
       By <a href="javascript:void(0);" @click="abrirSiteCliqx()">cliqx.com.br</a>
    </div>
  </div>
</template>


<script>


export default {

  directives: {  },
  components: { },

  data: () => ({ 

  }),

  created(){
  
  },

   methods: {

      abrirSiteCorreio: function(){
        window.open("https://buscacepinter.correios.com.br/app/endereco/index.php", "_blank");    
      },

      abrirSiteCliqx: function(){
        window.open("https://cliqx.com.br", "_blank");    
      },

      abrirSiteCliente: function(){
        window.open("https://www.urbs.curitiba.pr.gov.br", "_blank");
      },
   }

}

</script>
<style>

</style>
